import { initialAbility } from '@/libs/acl/config';
import ability from '../libs/acl'
import jwtConfig from './jwtConfig'
import store from '../store'

export default class AuthService {
  // store the User
  store = null;

  ability = null;

  initialised = false;

  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig }

    this.store = store

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        const accessToken = this.getToken()

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      error => {
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        // if (status === 401) {
        if (response && response.status === 401 && originalRequest.url !== '/refresh'
          && originalRequest.url !== '/login'
          && originalRequest.url !== '/verify'
          && originalRequest.url !== '/forgot-password') {
          if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true
            this.refreshCurrentUser().then(() => {
              this.onAccessTokenFetched(this.getToken())
            }, () => {})
          }
          const retryOriginalRequest = new Promise(resolve => {
            this.addSubscriber(accessToken => {
              // Make sure to assign accessToken according to your response.
              // Check: https://pixinvent.ticksy.com/ticket/2413870
              // Change Authorization header
              originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
              resolve(this.axiosIns(originalRequest))
            })
          })
          return retryOriginalRequest
        }
        return Promise.reject(error)
      },
    )
  }

  async refreshCurrentUser() {
    try {
      const r = await this.refreshToken()
      this.isAlreadyFetchingAccessToken = false
      this.setToken(r.data.accessToken)
      this.setCurrentUser(r.data.userData)
    } catch (err) {
      // Log err
    } finally {
      this.initialised = true;
    }
  }

  logout() {
    this.axiosIns.get(this.jwtConfig.logoutEndpoint)
    this.store.dispatch('user/clearUser')
    // Reset ability
    ability.update(initialAbility)
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return this.store.state.user.accessToken
  }

  setToken(value) {
    this.store.commit('user/SET_ACCESS_TOKEN', value);
  }

  getCurrentUser() {
    return this.store.state.user.currentUser
  }

  setCurrentUser(userData) {
    this.store.commit('user/SET_CURRENT_USER', userData);
    ability.update(userData.permissions)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  verify(token, ...args) {
    return this.axiosIns.put(`/reset-password/${token}`, ...args)
  }

  resetPassword(token, ...args) {
    return this.axiosIns.put(`/reset-password/${token}`, ...args)
  }

  refreshToken() {
    return this.axiosIns.get(this.jwtConfig.refreshEndpoint)
  }

  switch(...args) {
    return this.axiosIns.post('/organisations/switch', ...args)
  }

  forgotPassword(...args) {
    return this.axiosIns.post('/forgot-password', ...args)
  }
}
